export default __webpack_public_path__ + "static/media/dancing.a922bb9c.gif";